// extracted by mini-css-extract-plugin
export default {"search":"fh_hoG","search__input":"hnYdBD","searchInput":"hnYdBD","search__icon":"CR2oOp","searchIcon":"CR2oOp","search__icon--close":"QtQcXO","searchIconClose":"QtQcXO"};